import { FC, useState } from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import { InfoOutline } from '@mui/icons-material';
import { Row, Column } from 'further-ui/components/Layout';

type Props = {
  requiredTestResult: number | null;
  title: string;
  onBlur: (value: number) => void;
};

const ExperienceTestPassScoreField: FC<Props> = ({
  requiredTestResult,
  title,
  onBlur,
}) => {
  const [requiredTestResultError, setRequiredTestResultError] = useState<
    string | null
  >(null);

  return (
    <Column spacing="sm" fullWidth>
      <Row centered spacing="xxs">
        <Typography variant="body2">{title}</Typography>
        <Tooltip title="Select a score between 0 and 22 for automatic test passing. A highly experienced investor will receive a lower score. The default is 9. Entering 22 will pass all users automatically.">
          <InfoOutline fontSize="inherit" />
        </Tooltip>
      </Row>
      <TextField
        type="number"
        slotProps={{
          htmlInput: {
            min: 0,
            max: 22,
          },
        }}
        size="small"
        defaultValue={requiredTestResult}
        error={!!requiredTestResultError}
        helperText={requiredTestResultError}
        onBlur={(e) => {
          if (Number(e.target.value) < 0 || Number(e.target.value) > 22) {
            setRequiredTestResultError('Select score between 0 and 22.');
            return;
          }

          setRequiredTestResultError(null);

          onBlur(Number(e.target.value));
        }}
      />
    </Column>
  );
};

export default ExperienceTestPassScoreField;
